import React from "react";
import { Box, Search, TextField, Button } from "./styles";
import { Search as SearchIcon } from "@mui/icons-material";

export interface SearchProps {
  value: string;
  textHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  removeHandler: () => void;
  action: () => void;
  keyHandler: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchComponent = ({
  value,
  textHandler,
  removeHandler,
  action,
  keyHandler,
}: SearchProps) => {
  /**
   * 검색어 입력 후 Enter 로 검색을 실행한다. (돋보기 버튼 클릭과 동일)
   * IME(한글 등) 조합 확정용 Enter 는 검색으로 취급하지 않는다.
   */
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== "Enter") return;
    if (event.nativeEvent.isComposing) return;

    keyHandler(event);
  };

  return (
    <Box>
      <Search>
        <TextField
          placeholder="Search by edited user "
          value={value}
          onChange={textHandler}
          onKeyDown={handleKeyDown}
        />
        <Button onClick={action}>
          <SearchIcon sx={{ color: "#21005D" }} />
        </Button>
      </Search>
    </Box>
  );
};

export default SearchComponent;
